// test1205
(1205 && 0);
